import classNames from 'classnames';
import { DataTableHeaderProps, DataTableProps } from './types';
import { DataTableColumnHeader } from './cells/DataTableColumnHeader';

export function DataTableHeader<T extends string>({
  columns,
  columnAlignment,
  headers,
  condensed = false,
  sortableColumns,
  onSort,
  sort,
  maxHeight
}: DataTableProps<T> & DataTableHeaderProps<T>) {
  const sortColumn = (key: T) => {
    if (!sortableColumns) {
      return;
    }

    const primarySort = sortableColumns[key]?.direction ?? 'asc';
    const secondarySort = primarySort === 'asc' ? 'desc' : 'asc';

    if (sort?.key !== key || sort.direction === 'none') {
      onSort({ key, direction: primarySort });
      return;
    }

    if (sort.direction === primarySort) {
      onSort({ key, direction: secondarySort });
      return;
    }

    onSort({ key, direction: 'none' });
  };

  return (
    <thead className={classNames({ 'sticky top-0 z-10 bg-white': maxHeight })}>
      <tr className="text-sm">
        {columns.map(column => {
          const cell = headers[column];
          const alignment = columnAlignment?.[column];
          const sortable = sortableColumns?.[column];
          return (
            <DataTableColumnHeader
              key={column}
              column={column}
              alignment={alignment}
              condensed={condensed}
              onSortColumn={sortable && (() => sortColumn(column))}
              sortDirection={
                sortable && (sort?.key === column ? sort.direction : 'none')
              }
            >
              {cell}
            </DataTableColumnHeader>
          );
        })}
      </tr>
    </thead>
  );
}
